import { Address, Logo, SelectableAddress } from 'Types';

export type UserCategory = 'communityPartner' | 'businessPartner';

export enum UserType {
	b2bUser = 8,
	b2bAdmin = 4
}

export interface UserProfile {
	id: string;
	companyId: string;
	organizationName: string;
	companyName: string;
	userType: UserType;
	partnerType: number;
	firstName: string;
	lastName: string;
	avatar: Logo;
	username: string;
	address: Address;
	emailAddress: string;
	dateOfBirth: string;
	gender: string | number;
	userCategory: UserCategory;
	street: string;
	houseNumber: string;
	postalCode: string;
	city: string;
	state: string;
	country: string;
	mobileNumber: string;
	phoneNumber: string;
	permissions: string[];
}

export interface B2BUser {
	id: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	dateOfBirth: string;
	gender: string | number;
	avatar: Logo;
	address: Address;
	mobileNumber: number;
	phoneNumber: number;
}

export interface User {
	id: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	dateOfBirth: string;
	gender: string | number;
	avatar: Logo;
	address: Address;
	mobileNumber: number;
	phoneNumber: number;
}

export type UserAddress = SelectableAddress;

export interface UserGeneral {
	id: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	dateOfBirth: string;
	gender: string | number;
	avatar: Logo;
	address: Address;
	mobileNumber: number;
	phoneNumber: number;
}

export type UserInitialData = UserGeneral & UserAddress;

export interface UserFormData {
	firstName: string;
	lastName: string;
	emailAddress: string;
	dateOfBirth: string;
	gender: string | number;
	avatar: Logo;
	address: Address;
	mobileNumber: number;
	phoneNumber: number;
}


